import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Outlet } from 'react-router-dom';
import { IRootStoreProps, WithoutStore, withStore } from '../../stores';
import { AppContext, AppContextValue } from '../../theme/AppContextProvider';
import { ContentWrapp, FooterBlock, HeaderBlock, HeaderBlockMobile, Logo } from '../common';
import { NewsBlock } from './components';

class Home extends Component<IRootStoreProps> {
  static contextType = AppContext;
  state = { open: false };

  componentDidMount(): void {
    const { getNews, newsList } = this.props.store.user;
    if (!newsList.length) {
      getNews();
    }
  }

  render(): React.ReactNode {
    const { user } = this.props.store;
    const breakPoint = this.context as AppContextValue;

    if (breakPoint?.isMobile) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
          }}
        >
          <ContentWrapp style={{ flex: 1 }} isMobile>
            <HeaderBlockMobile>
              <Col style={{ padding: 10 }}>
                <Outlet />
              </Col>
            </HeaderBlockMobile>
          </ContentWrapp>
          <FooterBlock />
        </div>
      );
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <ContentWrapp style={{ flex: 1 }}>
          <Row gutter={8} style={{ marginTop: 16, minHeight: 360 }}>
            <Col span={5}>
              <Logo isAuth={user.isAuth} />
              <NewsBlock newsList={user.newsList} />
            </Col>
            <Col span={19}>
              <HeaderBlock />
              <Outlet />
            </Col>
          </Row>
        </ContentWrapp>
        <FooterBlock />
      </div>
    );
  }
}

export const HomeLayout: WithoutStore = withStore(observer(Home));
